import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LanguageAbbreviation } from '@/constants/common';
import translation_en from './en';
import translation_sw from './sw';
import { createTranslationTable, flattenObject } from './until';

const resources = {
  [LanguageAbbreviation.En]: translation_en,
  [LanguageAbbreviation.Sw]: translation_sw,
};
const enFlattened = flattenObject(translation_en);
const swFlattened = flattenObject(translation_sw);
export const translationTable = createTranslationTable(
  [enFlattened, swFlattened],
  ['English', 'Swahili'],
);
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      lookupLocalStorage: 'lng',
    },
    supportedLngs: Object.values(LanguageAbbreviation),
    resources,
    fallbackLng: 'sw',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
